import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";

import { MenuService } from "../service/menu.service";

@Injectable({
  providedIn: "root",
})
export class AccessMenuGuard implements CanActivate {
  private menuItems:any;
  constructor(private menuService: MenuService, private router: Router) {
 
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    // return this.menuService.currentMenu.pipe(
    //     map(element=>element.path==state.url),
    //     first()
    //     )
    if(this.menuService.currentMenuValue!=null){

        
       this.menuService.currentMenu.subscribe(data=>{
        let isValidRoute=false;
        data.forEach(element => {
            if("/"+element.path==state.url){
                isValidRoute=true;
            }
        });
        if(isValidRoute==false){
            this.router.navigate(["/authentication/page404"]);
            return false;
        }
          return true;
        
    })
    
    }else{
        return true;
    }

  }
}
